import { useMutation, useQuery } from '@tanstack/react-query';

import { AgentService } from '../../services';
import type { AgentExecutionRequest } from '../../domain';
import { queryKeys } from '../keys';

const AGENT_STALE_MS = 5 * 60_000;

/** List every registered agent (BE-seeded). */
export function useAgents() {
  return useQuery({
    queryKey: queryKeys.agents(),
    queryFn: () => AgentService.list(),
    staleTime: AGENT_STALE_MS,
  });
}

/** Fetch a single agent's metadata (name + description). */
export function useAgent(agentId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.agent(agentId ?? ''),
    queryFn: () => AgentService.get(agentId as string),
    enabled: !!agentId,
    staleTime: AGENT_STALE_MS,
  });
}

export function useExecuteAgent() {
  return useMutation({
    mutationFn: ({ agentId, request }: { agentId: string; request: AgentExecutionRequest }) =>
      AgentService.execute(agentId, request),
  });
}
